
import { locale } from './../globals.js';

const messages = {
	required: {
		'en': 'This field is required',
		'ar': 'هذا الحقل إلزامي'
	},
	requiredSelect: {
		'en': 'Please select',
		'ar': 'الرجاء اختيار'
	},
	email: {
		'en': 'Please enter a valid email address',
		'ar': 'رجاء إدخال عنوان بريد إلكتروني صحيح'
	},
	phone: {
		'en': 'Please enter a valid phone number',
		'ar': 'صحيح  يرجى إدخال رقم هاتف'
	},
	emiratesID: {
		'en': 'Please enter a valid Emirate ID number',
		'ar': 'يرجى إدخال رقم الهوية الإماراتية'
	},
	fileSize: {
		'en': 'File is too big',
		'ar': 'الملف كبير جدا'
	}
}

export function getMessage (id) {
  return messages[id][locale.lang];
}
export function errorLabel () {
  var label = document.createElement('div');
  label.classList.add('error-msg');
  return label;
}

export function formatFileSize(number) {
  if (number < 1024) {
    return number + 'bytes';
  } else if (number >= 1024 && number < 1048576) {
    return (number / 1024).toFixed(1) + 'KB';
  } else if (number >= 1048576) {
    return (number / 1048576).toFixed(1) + 'MB';
  }
}

export function validateEmail (email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export function itiLoad () {
  let style = document.createElement('link');
  style.setAttribute('rel', 'stylesheet');
  style.setAttribute('href', '/assets/lib/intl-tel-input/css/intlTelInput.min.css');
  document.querySelector('head').append(style);

  let script = document.createElement('script');
  script.setAttribute('src', '/assets/lib/intl-tel-input/js/intlTelInput.min.js')
  script.addEventListener('load', (event) => {
		intlTelInputGlobals.loadUtils('/assets/lib/intl-tel-input/js/utils.js');
		requestAnimationFrame(() => {
			document.body.dispatchEvent(new CustomEvent('itiloaded'))
		})
  })
  document.querySelector('body').append(script);
}
